import React from "react";
import { Carousel } from "react-bootstrap";

function MainBanner() {
  const myImages = ["image1.jpg", "image2.jpg", "image3.jpg", "image4.jpg"];
  return (
    <div>
      <Carousel>
        {myImages.map((item, i) => {
          return (
            <Carousel.Item key={i} interval={1500}>
              <img
                className="d-block w-100 img-fluid"
                src={`${process.env.PUBLIC_URL}/images/${item}`}
                alt="..."
              />
            </Carousel.Item>
          );
        })}
      </Carousel>
    </div>
  );
}
export default MainBanner;
